
// import * as SignalR from "@aspnet/signalr";

export default class PhoneSocket {
    socket = null;
    connectUrl: string = null;
    constructor(connectUrl: string) {
        this.connectUrl = connectUrl;

    }

    private generateRequestId() {
        const requestId = new Date().getTime() + Math.floor((Math.random() * 100000000000) + 1 );
        return requestId;
    }

    handleConnect() {
        // const socket = new SignalR.HubConnectionBuilder().withUrl(this.connectUrl).build();
        // return socket.start().then(() => {
        //     console.log('connect phone websocket successfull');
        //     this.socket = socket
        //     return Promise.resolve(true);
        // }).catch((err) => {
        //     return Promise.reject(err);
        // })
        return new Promise((resolve, reject) => {
            const socket = new WebSocket(this.connectUrl);
            socket.addEventListener('open', (event) => {
                console.log(`Connect to ${this.connectUrl} successful`);
                socket.send(`{ "METHOD": "PING", "REQUEST_ID": ${this.generateRequestId()}, "PAYLOAD": "" }`)
                this.socket = socket;
                // setTimeout(() => {
                //     socket.send('{ "METHOD": "NOTIFY", "PAYLOAD": { "AccountId":1234, "EventName": "Call", "Direction": "incoming", "To": "32482293482", "From": "+84/349/690.261", "CallerIdName": "", "CallId": "", "NextCallflow": "" } }')
                // }, 10000)
                return resolve(socket); 
            });
            socket.addEventListener('error', (event) => {
                return reject(event);
            });
        })
        
        // const socket2 = new WebSocket('ws://signalr.omnicasa.com/notifications?access_token=Xv3rMHryIxvInsDLICABP9AnR4d8trwmWJXZumU2EkQ.C5kXJ0rEOQ6cCxEz9TNdH13t8P5-plXFe2q3tLiI3O4');
        // socket2.addEventListener('message', function (event) {
        //     console.log('Message from server ', event.data);
        // });
    }
}